import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row items-start justify-start space-y-8 md:space-y-0 md:space-x-8" }
const _hoisted_2 = { class: "w-full md:w-3/5 bg-white py-2 grid grid-cols-1 sm:grid-cols-2 gap-8" }
const _hoisted_3 = { class: "col-span-full" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Max Total Supply")
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Mint Authority")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Freeze Authority")

import { toRefs } from 'vue';
import { AccountPresenter, TokenMintAccount } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: TokenMintAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_token_mint_card = _resolveComponent("token-mint-card")!
  const _component_base_label = _resolveComponent("base-label")!
  const _component_account_link = _resolveComponent("account-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_token_mint_card, {
      class: "w-full md:w-2/5",
      mint: _unref(account)
    }, null, 8, ["mint"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("p", {
          class: "tabular-nums text-gray-500",
          textContent: _toDisplayString(_unref(account).maxSupply.formattedWithSymbol)
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_account_link, {
          address: _unref(account).decodedData.mintAuthority
        }, null, 8, ["address"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_account_link, {
          address: _unref(account).decodedData.freezeAuthority
        }, null, 8, ["address"])
      ])
    ])
  ]))
}
}

})